import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import './assets/style/index.css';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';


Sentry.init({
  environment: "desarrollo",
  dsn: "https://56de3093b5924c71b4809690000136f3@o4504732550561792.ingest.sentry.io/4504732656795648",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();